export default __webpack_public_path__ + "static/media/bike-repair-station.e72ead2e.svg";